import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'adc-textbox',
  templateUrl: './adc-textbox.component.html',
  styleUrls: ['./adc-textbox.component.scss'],
  standalone: false
})
export class AdcTextboxComponent {
  @Input('type') type: any;
  @Input('data') data: any;
  @Input('inputStyle') inputStyle: any;
  @Output() inputValue: EventEmitter<any> = new EventEmitter();

  inputChanges(event: any) {
    const value = event.target.value;
    this.inputValue.emit(value);
  }
}
